import { Helmet } from 'react-helmet-async';

import { styled } from '@mui/material/styles';
import { Card, Container } from '@mui/material';

// ----------------------------------------------------------------------

const StyledContent = styled('div')({
    maxWidth: 900,
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    marginBottom: 30,
    marginTop: 20,
});

// ----------------------------------------------------------------------

export default function TermsPage() {
    return (
        <>
            <Helmet>
                <title>AI Exchange .Live | Terms and Conditions</title>
            </Helmet>

            <Container>
                <StyledContent sx={{ textAlign: 'left', alignItems: 'center' }}>
                    <Card sx={{ width: '100%', px: 6, py: 4, mt: 2, mb: 1 }}>
                        <h2>
                            Terms and Conditions
                        </h2>

                        <p>
                        Effective date: 2025-03-01
                        </p>

                        <p>By accessing and using <strong>AI Exchange .Live</strong> ("the Website"), you agree to comply with and be bound by the following terms and conditions:</p>

                        <h3>1. Purpose of the Website</h3>
                        <p>The Website provides exchange rate information and AI-generated insights related to market performance. All content provided on the Website is for informational purposes only.</p>

                        <h3>2. Accuracy of Information</h3>
                        <p>While we strive to provide accurate and up-to-date information, the exchange rates and market insights displayed on the Website are provided "as is" without any guarantees or warranties, either express or implied. We do not guarantee the accuracy, completeness, or timeliness of the information, and we are not responsible for any errors, inaccuracies, or omissions in the content.</p>

                        <h3>3. No Financial Advice</h3>
                        <p>The content on the Website does not constitute financial advice, investment advice, or any other type of professional guidance. Users should consult with a qualified financial advisor before making any decisions based on the information provided.</p>

                        <h3>4. Limitation of Liability</h3>
                        <p>To the fullest extent permitted by law, <strong>AI Exchange .Live</strong> will not be liable for any direct, indirect, incidental, special, or consequential damages resulting from the use or inability to use the Website or reliance on any information provided, including any loss of profit, data, or business opportunities.</p>

                        <h3>5. Use of the Website</h3>
                        <p>You agree to use the Website for lawful purposes and not engage in any activity that may harm the Website, its content, or its users. Any misuse of the Website may result in termination of access.</p>

                        <h3>6. Changes to the Terms</h3>
                        <p><strong>AI Exchange .Live</strong> reserves the right to modify or update these Terms and Conditions at any time. Any changes will be effective upon posting on this page. Please review these terms regularly to stay informed of any updates.</p>

                        <h3>7. Governing Law</h3>
                        <p>These Terms and Conditions shall be governed by and construed in accordance with the laws of Poland, without regard to its conflict of law principles.</p>

                        <p>If you have any questions about these Terms and Conditions, please contact us at <strong>contact@ai-exchange.live</strong>.</p>
                    </Card>
                </StyledContent>
            </Container>
        </>
    );
}
